import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";

import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertToDateString,
  LoadingSpinner,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../helper/Components";
import {
  GetCustomStyles,
  GetSelectedLanguage
} from "../helper/Method";
import { addMember } from "../member/ApiMember";
import SelectUnit from "../shared/SelectUnit";
import { ApiFinance } from "./ApiFinance";
import { ApiFund } from "./ApiFund";

const AddBulkFund = ({ history }) => {
  const { t } = useTranslation();

  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
  });
  const unitId = values.unit.value;
  const [loading, setLoading] = useState(false);
  const [fundValues, setFundValues] = useState({});
  const [fundValuesList, setFundValuesList] = useState([]);
  const [selectedDatesList, setSelectedDatesList] = useState([]);
  const [serverError, setServerError] = useState("");
  const [errors, setErrors] = useState({
    month: "",
    year: "",
  });
  const [members, setMembers] = useState([]);
  const [searchBtnClicked, setSearchBtnClicked] = useState(false);
  const [receiptType, setReceiptType] = useState("physical");

  const fetchUnitMembers = async () => {
    try {
      setLoading(true);
      setSearchBtnClicked(true);
      const res = await addMember().getUnitMembersForSelecting(
        values.unit.value
      );
      if (res.data.length === 0) {
        setMembers([]);
      } else {
        setMembers(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    let tempYear = currentDate.getFullYear();
    let tempMonth = currentDate.getMonth() + 1;
    setFundValues({
      unitId: unitId,
      month: tempMonth,
      year: tempYear,
      funds: [],
    });
  }, [unitId]);
  const [disablesubmitButton, setDisableSubmitButton] = useState(true);
  useEffect(() => {
    if (members?.length !== 0) {
      let currentDate = new Date();
      let temp = [];
      let tempDates = [];
      members.forEach((record) => {
        temp.push({
          memberId: record?.id,
          memberName: record?.name,
          receiptNumber: "",
          amount: null,
          date: currentDate,
        });

        tempDates.push({
          memberId: record?.id,
          date: currentDate,
        });
      });

      setSelectedDatesList(tempDates);
      setFundValuesList(temp);
    } else {
      setSelectedDatesList([]);
      setFundValuesList([]);
    }
  }, [members]);
  const validate = () => {
    let temp = {};
    temp.month = fundValues.month ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_month_error" />
    );
    temp.year = fundValues.year ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_year_error" />
    );
    temp.selectedBankAccountErrorMsg = selectedBankAccount
      ? ""
      : "Please select a Bank Account";
    temp.selectedInfaqHeadErrorMsg = selectedInfaqHead
      ? ""
      : "Please select an Account Head";

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChangeDate = (value, index) => {
    let tempValues = [...selectedDatesList];
    tempValues[index].date = value;

    setSelectedDatesList(tempValues);
  };

  const handleInputChange = (e, index) => {
    let { name, value } = e.target;
    if (name === "amount") {
      value = value.replace(/[^0-9.]/g, "");
    }
    setDisableSubmitButton(false);
    let tempValues = [...fundValuesList];
    if (!tempValues[index]) {
      tempValues[index] = {};
    }
    tempValues[index][name] = value;

    setFundValuesList(tempValues);
  };
  const [duplicateRows, setDuplicateRows] = useState([]);

  const handleSubmit = () => {
    const frontDuplicates = validateReceiptsFrontend();

    if (frontDuplicates.length > 0) {
      setDuplicateRows(frontDuplicates);
      return;
    }

    setDuplicateRows([]);
    if (validate()) {
      setLoading(true);
      const updatedFunds = fundValuesList.map((fund) => {
        const matchingDate = selectedDatesList.find(
          (date) => date.memberId === fund.memberId
        );
        return {
          ...fund,
          receiptNumber: receiptType === "digital" ? "" : fund.receiptNumber,
          date: matchingDate ? convertToDateString(matchingDate.date) : null,
        };
      });

      // derive month/year for the bulk payload from the current date
      const currentDate = new Date();
      const monthToSend = currentDate.getMonth() + 1;
      const yearToSend = currentDate.getFullYear();

      fundValues.funds = updatedFunds;
      fundValues.month = monthToSend;
      fundValues.year = yearToSend;
      fundValues.codeId = selectedInfaqHead?.value || "";
      fundValues.bankAccountId = selectedBankAccount?.value || "";
      fundValues.GenerateDigitalReceipt = receiptType === "digital";
      const hasAtLeastOneValidFund = fundValuesList.some(
        (item) => Number(item.amount) > 0
      );

      if (!hasAtLeastOneValidFund) {
        swal({
          title: t("all_member_zero_amount_error"),
          icon: "error",
          buttons: "OK",
        });
        setLoading(false);
        return;
      }
      ApiFund()
        .addBulkFund(fundValues)
        .then((res) => {
          if (res.data.statusCode === "200") {
            swal({
              title: t("member_member_detail_fund_added"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: "OK",
            });
            setLoading(false);
            history.goBack();
          } else {
            const duplicateCount = res.data.duplicateCount;
            swal({
              title:
                `${duplicateCount} ${t(res.data.message)}` ||
                t("all_member_zero_amount_error"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "error",
              buttons: "OK",
            });
            if (res.data.duplicateList && res.data.duplicateList.length > 0) {
              // map receipt numbers to row indexes
              const backendDupIndexes = fundValuesList
                .map((item, idx) =>
                  res.data.duplicateList.includes(item.receiptNumber)
                    ? idx
                    : null
                )
                .filter((idx) => idx !== null);

              setDuplicateRows(backendDupIndexes);
            }
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response.data.length < 100) {
            setServerError(err.response.data);
          }
          swal({
            title: t("member_member_detail_fund_added_error"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });
    }
  };
  const validateReceiptsFrontend = () => {
    if (receiptType === "digital") return [];

    let duplicates = [];
    let seen = new Set();

    fundValuesList.forEach((item, index) => {
      if (item.receiptNumber && seen.has(item.receiptNumber)) {
        duplicates.push(index);
      }
      seen.add(item.receiptNumber);
    });

    return duplicates;
  };

  const handleReceiptTypeChange = (e) => {
    const value = e.target.value;
    setReceiptType(value);
    setDuplicateRows([]);

    if (value === "digital") {
      setFundValuesList((prev) =>
        prev.map((fund) => ({
          ...fund,
          receiptNumber: "",
        })),
      );
    }
  };

  const [bankAccountList, setBankAccountList] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [infaqHeads, setInfaqHeads] = useState([]);
  const [selectedInfaqHead, setSelectedInfaqHead] = useState(null);

  useEffect(() => {
    const financeApi = ApiFinance();
    financeApi
      .GetFinanceCategoryAccountsByCode("infaq")
      .then((res) => {
        if (res?.data) {
          setInfaqHeads(res.data);

          // default select first one
          if (res.data.length > 0) {
            setSelectedInfaqHead(res.data[0]);
            setFundValues((prev) => ({
              ...prev,
              codeId: res.data[0].value,
            }));
          }
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    const financeApi = ApiFinance();
    financeApi.GetFinanceBankAccounts(unitId).then((res) => {
      const filteredAccounts = (res.data || []).filter(
        (account) => account?.label1 === "cash_in_hand_account",
      );

      if (filteredAccounts.length > 0) {
        setBankAccountList(filteredAccounts);
        setSelectedBankAccount(filteredAccounts[0]);
        setFundValues((prev) => ({
          ...prev,
          bankAccountId: filteredAccounts[0].value,
        }));
      } else {
        // when array is empty
        setBankAccountList([]);
        setSelectedBankAccount(null); // or {} if your UI expects an object
        setFundValues((prev) => ({
          ...prev,
          bankAccountId: null, // or "" depending on your backend requirement
        }));
      }
    });
  }, [unitId]);

  const handleBankAccountChange = (selected) => {
    setSelectedBankAccount(selected);

    setFundValues((prev) => ({
      ...prev,
      bankAccountId: selected?.value || "",
    }));

    setErrors((prev) => ({
      ...prev,
      selectedBankAccountErrorMsg: selected
        ? ""
        : "Please select a Bank Account",
    }));
  };
  const handleInfaqHeadChange = (selected) => {
    setSelectedInfaqHead(selected);

    setFundValues((prev) => ({
      ...prev,
      codeId: selected ? selected.value : "",
    }));

    setErrors((prev) => ({
      ...prev,
      selectedInfaqHeadErrorMsg: selected
        ? ""
        : "Please select an Account Head",
    }));
  };
  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox ">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="funds_add_bulk_fund" />}</h5>
          <Button
            className={GetCustomStyles().btn_style}
            color="white"
            size="xs"
            onClick={() => history.goBack()}
          >
            {" "}
            <IoArrowBackSharp
              color="#18A689"
              size={15}
              style={{ marginRight: 5, marginBottom: 1 }}
            />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>
        <div className="ibox-content">
          {serverError && <h4 className="text-danger">{serverError}</h4>}

          <SelectUnit
            values={values}
            setValues={setValues}
            unitId={values.unit.value}
          />
          <Row>
            {/* Bank Account */}
            <Col md="4">
              <FormGroup>
                <Label className="col-form-label">
                  <GetLanguageString props="fund_bank_account" />
                </Label>
                <Select
                  options={bankAccountList}
                  value={selectedBankAccount}
                  placeholder="Select bank account"
                  onChange={handleBankAccountChange}
                  className="basic-single no-drag"
                  classNamePrefix="select"
                  isDisabled
                />

                {errors.selectedBankAccountErrorMsg && (
                  <h4 className="text-error">
                    {errors.selectedBankAccountErrorMsg}
                  </h4>
                )}
              </FormGroup>
            </Col>

            {/* INFAQ HEAD */}
            <Col md="4">
              <FormGroup>
                <Label className="col-form-label">
                  <GetLanguageString props="fund_account_head" />
                </Label>
                <Select
                  options={infaqHeads}
                  value={selectedInfaqHead}
                  placeholder="Select Infaq Head"
                  onChange={handleInfaqHeadChange}
                  className="basic-single no-drag"
                  classNamePrefix="select"
                />

                {errors.selectedInfaqHeadErrorMsg && (
                  <h4 className="text-error">
                    {errors.selectedInfaqHeadErrorMsg}
                  </h4>
                )}
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label className="col-form-label d-block">&nbsp;</Label>
                <div
                  className="no-drag d-flex align-items-center justify-content-center"
                  style={{ gap: 24, minHeight: 38 }}
                >
                  <Label check className="mb-0">
                    <Input
                      type="radio"
                      name="bulkReceiptType"
                      value="physical"
                      checked={receiptType === "physical"}
                      onChange={handleReceiptTypeChange}
                    />{" "}
                    {<GetLanguageString props="funds_physical_receipt" />}
                  </Label>
                  <Label check className="mb-0">
                    <Input
                      type="radio"
                      name="bulkReceiptType"
                      value="digital"
                      checked={receiptType === "digital"}
                      onChange={handleReceiptTypeChange}
                    />{" "}
                    {<GetLanguageString props="funds_digital_receipt" />}
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md="12" className="text-center">
              <div style={{ marginTop: 10 }}>
                <Button
                  color="primary"
                  className="m-l-sm"
                  onClick={fetchUnitMembers} //
                >
                  {<GetLanguageString props="common_search" />}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {searchBtnClicked && (
        <>
          {!loading ? (
            <>
              <div className="ibox">
                <div className="ibox-content">
                  {serverError && (
                    <h4 className="text-danger">{serverError}</h4>
                  )}

                  {fundValuesList.length !== 0 ? (
                    <>
                      <Table>
                        <thead>
                          <tr style={{ borderBottom: "1px solid black" }}>
                            <th>#</th>
                            <th>{<GetLanguageString props="common_name" />}</th>
                            <th>{<GetLanguageString props="funds_date" />}</th>
                            {receiptType === "physical" && (
                              <th>
                                {
                                  <GetLanguageString props="funds_receipt_number" />
                                }
                              </th>
                            )}
                            <th>
                              {
                                <GetLanguageString props="funds_add_fund_amount" />
                              }
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {fundValuesList?.map((record, index) => (
                            <tr
                              key={index}
                              style={{ borderBottom: "1px solid grey" }}
                              className={
                                duplicateRows.includes(index) ? "table-danger" : ""
                              }
                            >
                              <td>{index + 1}</td>
                              <td>
                                <h4>{applyClassToCharacters(record?.memberName, "ur")}</h4>
                              </td>
                              <td>
                                <DatePicker
                                  minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                                  maxDate={new Date()}
                                  placeholderText="dd/mm/yyyy"
                                  className="form-control no-drag"
                                  dateFormat="dd/MM/yyyy"
                                  selected={selectedDatesList[index]?.date}
                                  onChange={(v) => handleInputChangeDate(v, index)}
                                />
                              </td>
                              {receiptType === "physical" && (
                                <td>
                                  <Input
                                    autoFocus={index === 0}
                                    type="text"
                                    className="no-drag"
                                    name="receiptNumber"
                                    value={fundValuesList[index]?.receiptNumber}
                                    onChange={(e) => handleInputChange(e, index)}
                                  />
                                </td>
                              )}
                              <td>
                                <Input
                                  type="text"
                                  className="no-drag"
                                  name="amount"
                                  value={fundValuesList[index]?.amount}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <Row
                        style={{
                          backgroundColor: "white",
                          marginLeft: 2,
                          marginRight: 2,
                          height: 50,
                        }}
                      >
                        <div style={{ marginTop: 10 }}>
                          <Button
                            color="primary"
                            className={GetCustomStyles().btn_style}
                            onClick={() => handleSubmit()}
                            disabled={disablesubmitButton}
                          >
                            {<GetLanguageString props="common_save_changes" />}
                          </Button>
                          <Button
                            color="white"
                            className={GetCustomStyles().btn_style}
                            onClick={() => history.goBack()}
                          >
                            {<GetLanguageString props="common_cancel" />}
                          </Button>
                        </div>
                      </Row>
                    </>
                  ) : (
                    <NoResult />
                  )}
                </div>
              </div>
            </>
          ) : (
            LoadingSpinner()
          )}
        </>
      )}
    </div>
  );
};

export default withRouter(AddBulkFund);
